import * as Scrivito from "scrivito";

const GlobalConfigPage = Scrivito.provideObjClass("GlobalConfigPage", {
  attributes: {
    body: ["widgetlist", { only: ["NewsCategoryConfigWidget"] }],
  },
  extractTextAttributes: ["body"],
});

export default GlobalConfigPage;
